import type { IconDefinition } from '../index.tsx';

export const iconFire: IconDefinition = {
  prefix: 'fas',
  iconName: 'iconFire',
  icon: [
    16,
    16,
    [],
    '',
    'M11.3895 6.01516H11.6881H11.69V4.22909L14.4353 7.56981V12.2487L10.5496 15.9907L9.18721 10.75H7.16785L5.6524 16H5.57215L2 12.5249V3.85956L5.19701 6.25405H5.59454V0L11.3895 6.01516Z',
  ],
};
